import { render, staticRenderFns } from "./ResendVoucher.vue?vue&type=template&id=53b2bc44&"
import script from "./ResendVoucher.vue?vue&type=script&lang=js&"
export * from "./ResendVoucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53b2bc44')) {
      api.createRecord('53b2bc44', component.options)
    } else {
      api.reload('53b2bc44', component.options)
    }
    module.hot.accept("./ResendVoucher.vue?vue&type=template&id=53b2bc44&", function () {
      api.rerender('53b2bc44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/ResendVoucher.vue"
export default component.exports